import { render, staticRenderFns } from "./info-preview.vue?vue&type=template&id=139de4e6&scoped=true&"
import script from "./info-preview.vue?vue&type=script&lang=js&"
export * from "./info-preview.vue?vue&type=script&lang=js&"
import style0 from "./info-preview.vue?vue&type=style&index=0&id=139de4e6&scoped=true&lang=css&"
import style1 from "./info-preview.vue?vue&type=style&index=1&id=139de4e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139de4e6",
  null
  
)

export default component.exports